import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Table, Spinner, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Modal, ModalHeader, ModalBody, ModalFooter, Label } from "reactstrap";
import { getPartner } from "../../redux/actions/indexActions";
import { AiOutlineEdit, AiOutlineDelete, AiOutlineEye } from "react-icons/ai";
import { FaEllipsisV } from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { Button } from "reactstrap";
import { MdAdd } from "react-icons/md";
import { Input } from "reactstrap";
import Pagination from "../../Components/Paginate";
import { CSVLink } from "react-csv";
import { BiSolidFileExport } from "react-icons/bi";
import moment from "moment";

const PartnersList = () => {
  const { pathname } = useLocation();
  const dispatch = useDispatch();

  const {
    AuthReducer: { auth },
    indexReducer: { PartnerLists, partnerCount },
    PermissionReducer: { allowedPermissions },
  } = useSelector((state) => state);
  const [page, setPage] = useState(0);
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState("desc");
  const [paginate, setPaginate] = useState(50);
  const [loading, setLoading] = useState(false);
  const [pageType, setPageType] = useState("");
  const [actionDropdowns, setActionDropdowns] = useState({});
  const [statusDropdowns, setStatusDropdowns] = useState({});
  const [verificationModal, setVerificationModal] = useState(false);
  const [selectedPartner, setSelectedPartner] = useState(null);
  const [verificationStatus, setVerificationStatus] = useState(1); // 1=Verified, 0=Pending, 2=Rejected
  const [disposition, setDisposition] = useState("");
  const [verificationReason, setVerificationReason] = useState("");
  const [verificationSubmitting, setVerificationSubmitting] = useState(false);

  const leadDispositions = [
    {
      value: 1,
      options: [
        { label: "Partner Qualified", value: "Partner Qualified" },
        { label: "Partner Converted", value: "Partner Converted" },
        { label: "Documents Verified", value: "Documents Verified" },
        { label: "Payment Completed", value: "Payment Completed" },
        { label: "Management Approved", value: "Management Approved" },
        { label: "Partner Approved", value: "Partner Approved" }
      ]
    },
    {
      value: 0,
      options: [
        { label: "Follow Up Required", value: "Follow Up Required" },
        { label: "Under Review", value: "Under Review" },
        { label: "Waiting for Documents", value: "Waiting for Documents" },
        { label: "Client Decision Pending", value: "Client Decision Pending" },
        { label: "Verification in Process", value: "Verification in Process" }
      ]
    },
    {
      value: 2,
      options: [
        { label: "Not Interested", value: "Not Interested" },
        { label: "Invalid Partner", value: "Invalid Partner" },
        { label: "Budget Issue", value: "Budget Issue" },
        { label: "Duplicate Partner", value: "Duplicate Partner" },
        { label: "Out of Service Area", value: "Out of Service Area" }
      ]
    }
  ];

  const dispositionOptionsByStatus = [
    { value: "", label: "Select Disposition" },
    ...(leadDispositions.find((d) => d.value === verificationStatus)?.options ?? []),
  ];

  let pageTitle = "Partner List";
  let page_type = "";
  const isPartnerRegistrationSubTab =
    pathname.includes("approved-partners") ||
    pathname.includes("pending-partners") ||
    pathname.includes("rejected-partners");
  
  if (pathname.includes("approved-partners")) {
    pageTitle = "Approved/Verified Partners";
    page_type = 1;
  } else if (pathname.includes("pending-partners")) {
    pageTitle = "Pending Partners Requests";
    page_type = 0;
  } else if (pathname.includes("rejected-partners")) {
    pageTitle = "Rejected Partners";
    page_type = 2;
  }

  useEffect(() => {
    setPage(0);
    setPaginate(50);
  }, [page_type]);
  // setPageType(page_type);

  useEffect(() => {
    setLoading(true);
    dispatch(getPartner(auth?.token, paginate, page, search, sort, page_type));
    setLoading(false);
  }, [auth, paginate, page, search, sort, page_type]);
  console.log(PartnerLists);
  const csvHead = [["name", "description", "logo"]];
  const csvData = PartnerLists.map((cv) => [
    cv?.name,
    cv?.description,
    cv?.logo,
  ]);
  const exportData = csvHead.concat(csvData);

  const handleDel = (id) => {
    if (window.confirm("Are You Sure You Want To Delete This Partner")) {
      axios
        .delete(`/api/admin/v1/partner-delete/${id}`, {
          headers: {
            Authorization: `Bearer ${auth?.token}`,
          },
        })
        .then((res) => {
          toast.success(res.data.message);
          dispatch(getPartner(auth?.token));
        })
        .catch((err) => toast.error("Somthing Went Wrong"));
    }
  };

  const handleStatusChange = async (partnerId, status) => {
    try {
      const response = await axios.put(
        `/api/admin/v1/partner-status/${partnerId}`,
        { status },
        { headers: { Authorization: `Bearer ${auth?.token}` } }
      );
      const statusText = status === 1 ? 'Active' : status === 2 ? 'Hold' : 'Inactive';
      toast.success(`Partner status updated to ${statusText}`);
      dispatch(getPartner(auth?.token, paginate, page, search, sort, page_type));
    } catch (error) {
      toast.error("Failed to update partner status");
    }
  };

  const openVerificationModal = (item) => {
    setSelectedPartner(item);
    setVerificationStatus(item?.isVerified === 1 ? 1 : item?.isVerified === 2 ? 2 : 0);
    setDisposition("");
    setVerificationReason("");
    setVerificationModal(true);
  };

  const closeVerificationModal = () => {
    setVerificationModal(false);
    setSelectedPartner(null);
    setVerificationStatus(1);
    setDisposition("");
    setVerificationReason("");
  };

  const handleVerificationSubmit = async () => {
    if (!selectedPartner?.id) return;
    setVerificationSubmitting(true);
    try {
      await axios.post(
        "/api/admin/v1/verify-partner-registration",
        {
          partnerId: selectedPartner.id,
          status: verificationStatus,
          reason: disposition || "",
          remarks: verificationReason || "",
        },
        { headers: { Authorization: `Bearer ${auth?.token}` } }
      );
      toast.success("Partner verification status updated successfully!");
      closeVerificationModal();
      dispatch(getPartner(auth?.token, paginate, page, search, sort, page_type));
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to update verification status");
    } finally {
      setVerificationSubmitting(false);
    }
  };

  return (
    <div>
      <div className="row my-3">
        <div className="col-md-12">
          <div className="mb-4 d-flex align-items-center justify-content-between">
            <h5 className="mb-0 text-white fs-4">{pageTitle}</h5>
            {allowedPermissions?.some?.(
              (item) =>
                item?.permission?.moduleType === "PARTNERS" &&
                item?.permission?.permission === "create"
            ) && (
              <Link to="/add-partner">
                <Button className="bg-white text-black" size="sm">
                  <span className="me-2">
                    <MdAdd size={22} />
                  </span>
                  Add Partner
                </Button>
              </Link>
            )}
          </div>
        </div>
      </div>
      <div
        className="bg-white px-3 py-4 rounded-2  my-4"
        style={{ boxShadow: "4px 4px 18px rgba(0,0,0,0.15)" }}
      >
        <div className="row">
          <div className="col-md-3 mb-2">
            <Input
              size={"sm"}
              value={search}
              placeholder="Search By Name"
              onChange={({ target: { value } }) => setSearch(value)}
            />
          </div>
          <div
            className={`col-md-2 ${
              allowedPermissions?.some?.(
                (item) =>
                  item?.permission?.moduleType === "PARTNERS" &&
                  item?.permission?.permission === "export"
              )
                ? "offset-md-6"
                : "offset-md-7"
            }`}
          >
            <Input
              type="select"
              size={"sm"}
              value={sort}
              onChange={({ target }) => setSort(target.value)}
            >
              <option value="asc">Ascending</option>
              <option value="desc">Descending</option>
            </Input>
          </div>
          {allowedPermissions?.some?.(
            (item) =>
              item?.permission?.moduleType === "PARTNERS" &&
              item?.permission?.permission === "export"
          ) && (
            <div className="col-md-1 mb-2">
              <CSVLink
                filename={"partner-lists.csv"}
                className="text-black ms-1"
                title="Export To CSV"
                data={exportData}
              >
                <BiSolidFileExport size={25} />
              </CSVLink>
            </div>
          )}
          <div className="col-md-12">
            <Table hover responsive>
              <thead>
                <tr>
                  <th>SL. No.</th>
                  <th>Partner Name</th>
                  <th>Category</th>
                  <th>Sub Category</th>
                  <th>Refrence ID</th>
                  <th>Full Name</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Designation</th>
                  <th>City</th>
                  <th>State</th>
                  <th>Registrated On</th>
                  <th>Disposition</th>
                  <th>Remark</th>
                  <th>Verified</th>
                  {!isPartnerRegistrationSubTab && <th>Status</th>}
                  {!isPartnerRegistrationSubTab &&
                    allowedPermissions?.some?.(
                      (item) =>
                        item?.permission?.moduleType === "PARTNERS" &&
                        (item?.permission?.permission === "edit" ||
                          item?.permission?.permission === "delete")
                    ) && <th>Action</th>}
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="15">
                      <Spinner />
                    </td>
                  </tr>
                ) : PartnerLists.length === 0 ? (
                  <tr>
                    <td colSpan="15">No data found</td>
                  </tr>
                ) : (
                  <>
                    {PartnerLists?.map?.((item, index) => {
                      return (
                        <tr key={item.id}>
                          <th scope="row">{index + 1 + page * paginate}</th>
                          <td>{item?.businessName ?? "N/A"}</td>
                          <td>{item?.category ?? "N/A"}</td>
                          <td>{item?.sub_category ?? "N/A"}</td>
                          <td>{item?.registration_id ?? "N/A"}</td>
                          <td>{item?.fullName ?? "N/A"}</td>
                          <td>{item?.email ?? "N/A"}</td>
                          <td>{item?.phoneNumber ?? "N/A"}</td>
                          <td>{item?.designation ?? "N/A"}</td>
                          <td>{item?.city ?? "N/A"}</td>
                          <td>{item?.partnerState ? item?.partnerState?.state_name : "N/A"}</td>
                          <td>{item?.createdAt ? moment(item.createdAt).format("DD-MM-YYYY hh:mm A") : "N/A"}</td>
                          <td>{item?.reason ?? "N/A"}</td>
                          <td>{item?.remarks ?? "N/A"}</td>
                          {/* <td>
                            {item?.logo ? (
                              <img
                                src={
                                  process.env.REACT_APP_IMAGE_URL +
                                  `/${item?.logo}`
                                }
                                height={45}
                                width={45}
                                alt="logo"
                              />
                            ) : (
                              <span>-</span>
                            )}
                          </td> */}
                            <td
                            role="button"
                            tabIndex={0}
                            onClick={() => openVerificationModal(item)}
                            onKeyDown={(e) => e.key === "Enter" && openVerificationModal(item)}
                            style={{
                              backgroundColor: item?.isVerified === 1
                                ? "lightgreen"
                                : item?.isVerified === 2
                                  ? "lightcoral"
                                  : "lightyellow",
                              color: "#696464ff",
                              textAlign: "center",
                              fontWeight: "bold",
                              cursor: "pointer",
                            }}
                          >
                            {item?.isVerified === 1 ? "Verified" : item?.isVerified === 2 ? "Rejected" : "Pending"}
                          </td>
                          {!isPartnerRegistrationSubTab && (
                            <td>
                              <Dropdown
                                isOpen={statusDropdowns[item.id] || false}
                                toggle={() => setStatusDropdowns(prev => ({ ...prev, [item.id]: !prev[item.id] }))}
                              >
                                <DropdownToggle 
                                  className={`btn btn-sm ${
                                    item?.status === 1 ? 'btn-success' : 
                                    item?.status === 2 ? 'btn-warning' : 'btn-danger'
                                  }`}
                                >
                                  {item?.status === 1 ? 'Active' : 
                                   item?.status === 2 ? 'Hold' : 'Inactive'}
                                </DropdownToggle>
                                <DropdownMenu>
                                  <DropdownItem onClick={() => handleStatusChange(item.id, 1)}>
                                    <span className="text-success">● Active</span>
                                  </DropdownItem>
                                  <DropdownItem onClick={() => handleStatusChange(item.id, 2)}>
                                    <span className="text-warning">● Hold</span>
                                  </DropdownItem>
                                  <DropdownItem onClick={() => handleStatusChange(item.id, 0)}>
                                    <span className="text-danger">● Inactive</span>
                                  </DropdownItem>
                                </DropdownMenu>
                              </Dropdown>
                            </td>
                          )}
                        

                          {!isPartnerRegistrationSubTab &&
                            allowedPermissions?.some?.(
                              (perm) =>
                                perm?.permission?.moduleType === "PARTNERS" &&
                                (perm?.permission?.permission === "edit" ||
                                  perm?.permission?.permission === "delete")
                            ) && (
                              <td>
                                <Dropdown
                                  isOpen={actionDropdowns[item.id] || false}
                                  toggle={() => setActionDropdowns(prev => ({ ...prev, [item.id]: !prev[item.id] }))}
                                >
                                  <DropdownToggle className="btn btn-sm btn-outline-secondary">
                                    <FaEllipsisV  className="text-white"/>
                                  </DropdownToggle>
                                  <DropdownMenu>
                                    <DropdownItem onClick={() => window.open(`/partner-details/${item.id}`, '_blank')}>
                                      <AiOutlineEye className="me-2" /> View Details
                                    </DropdownItem>
                                    {allowedPermissions?.some?.(
                                      (perm) =>
                                        perm?.permission?.moduleType === "PARTNERS" &&
                                        perm?.permission?.permission === "edit"
                                    ) && (
                                      <DropdownItem onClick={() => window.open(`/edit-partner/${item.id}`, '_blank')}>
                                        <AiOutlineEdit className="me-2" /> Edit Partner
                                      </DropdownItem>
                                    )}
                                    {allowedPermissions?.some?.(
                                      (perm) =>
                                        perm?.permission?.moduleType === "PARTNERS" &&
                                        perm?.permission?.permission === "delete"
                                    ) && (
                                      <>
                                        <DropdownItem divider />
                                        <DropdownItem onClick={() => handleDel(item.id)} className="text-danger">
                                          <AiOutlineDelete className="me-2" /> Delete Partner
                                        </DropdownItem>
                                      </>
                                    )}
                                  </DropdownMenu>
                                </Dropdown>
                              </td>
                            )}
                        </tr>
                      );
                    })}
                  </>
                )}
              </tbody>
            </Table>
          </div>
        </div>
        <div className="row align-items-center">
          <div className="col-md-6 d-flex">
            <div className="col-md-2">
              <Input
                type="select"
                id="paginate"
                value={paginate}
                onChange={(e) => {
                  setPaginate(Number(e.target.value));
                  setPage(0);
                }}
              >
                <option value={50}>50</option>
                <option value={100}>100</option>
                <option value={200}>200</option>
                <option value={500}>500</option>
              </Input>
            </div>
          </div>
          <div className="col-md-6">
            <Pagination
              pageCount={Math.ceil((partnerCount || 0) / paginate) || 1}
              currentPage={page}
              onChange={(e) => setPage(e.selected)}
            />
          </div>
        </div>
      </div>

      <Modal isOpen={verificationModal} toggle={closeVerificationModal} size="md">
        <ModalHeader toggle={closeVerificationModal}>
          Update Verification Status
          {selectedPartner && (
            <span className="ms-2 text-muted small">
              — {selectedPartner?.businessName || selectedPartner?.fullName}
            </span>
          )}
        </ModalHeader>
        <ModalBody>
          <div className="mb-3">
            <Label className="d-block mb-2 fw-semibold">Status</Label>
            <div className="d-flex flex-wrap gap-3">
            <label className="d-flex align-items-center gap-2" style={{ cursor: "pointer" }}>
                <input
                  type="radio"
                  name="verificationStatus"
                  checked={verificationStatus === 0}
                  onChange={() => { setVerificationStatus(0); setDisposition(""); }}
                />
                <span>Pending</span>
              </label>
              <label className="d-flex align-items-center gap-2" style={{ cursor: "pointer" }}>
                <input
                  type="radio"
                  name="verificationStatus"
                  checked={verificationStatus === 1}
                  onChange={() => { setVerificationStatus(1); setDisposition(""); }}
                />
                <span>Verified</span>
              </label>
              <label className="d-flex align-items-center gap-2" style={{ cursor: "pointer" }}>
                <input
                  type="radio"
                  name="verificationStatus"
                  checked={verificationStatus === 2}
                  onChange={() => { setVerificationStatus(2); setDisposition(""); }}
                />
                <span>Rejected</span>
              </label>
            </div>
          </div>
          <div className="mb-3">
            <Label for="disposition" className="d-block mb-2 fw-semibold">Disposition</Label>
            <Input
              id="disposition"
              type="select"
              value={disposition}
              onChange={(e) => setDisposition(e.target.value)}
            >
              {dispositionOptionsByStatus.map((opt) => (
                <option key={opt.value} value={opt.value}>{opt.label}</option>
              ))}
            </Input>
          </div>
          <div>
            <Label for="verificationReason" className="d-block mb-2 fw-semibold">Reason for status change</Label>
            <Input
              id="verificationReason"
              type="textarea"
              rows={3}
              value={verificationReason}
              onChange={(e) => setVerificationReason(e.target.value)}
              placeholder="Enter reason (optional)"
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={closeVerificationModal} disabled={verificationSubmitting}>
            Cancel
          </Button>
          <Button color="primary" onClick={handleVerificationSubmit} disabled={verificationSubmitting}>
            {verificationSubmitting ? "Updating..." : "Update"}
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default PartnersList;
